import { render } from "./StoryboardClient.vue?vue&type=template&id=5d0f0ca0&scoped=true"
import script from "./StoryboardClient.vue?vue&type=script&lang=js"
export * from "./StoryboardClient.vue?vue&type=script&lang=js"

import "./StoryboardClient.vue?vue&type=style&index=0&id=5d0f0ca0&scoped=true&lang=css"

import exportComponent from "C:\\ExactFloMarketingTool\\exactfloMarketingTool\\frontend\\marketingtool\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0f0ca0"]])

export default __exports__